import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { FALLBACK_PROJECTS } from "@/data/site";
import { Reveal, SectionHeading } from "@/components/Reveal";
import ProjectCard from "@/components/ProjectCard";
import ProjectLightbox from "@/components/ProjectLightbox";

export default function ProjectsPreview() {
  const [projects, setProjects] = useState(FALLBACK_PROJECTS);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => {});
  }, []);

  const featured = projects.filter((p) => p.featured).slice(0, 4);
  const shown = featured.length >= 3 ? featured : projects.slice(0, 4);

  return (
    <section data-testid="projects-preview-section" className="bg-ivory py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            align="left"
            eyebrow="Signature Projects"
            title="Stories Set in Stone"
            script="Big Walls, Bigger Stories"
            description="A selection of residences, resorts, offices and sacred spaces — each carved around its own story."
          />
          <Reveal delay={0.15}>
            <Link
              to="/projects"
              data-testid="projects-view-all"
              className="group flex w-fit items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-gold-dark transition-colors hover:text-gold"
            >
              View All Projects
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
            </Link>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {shown.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.12} className={i === 0 ? "md:col-span-2 lg:row-span-2" : ""}>
              <ProjectCard project={p} onSelect={setSelected} className="h-full" />
            </Reveal>
          ))}
        </div>
      </div>
      <ProjectLightbox project={selected} onClose={() => setSelected(null)} />
    </section>
  );
}
